import React from 'react'

const Badge = props => {
  const { label = '', className = '' } = props

  return <div className={`badge ${className ? ` ${className}` : ''}`}>{label}</div>
}

export default Badge
